import { isAnalyticsEnabled } from '@pes-ui/utils';

/**
 * @typedef {object} LookupsDictionary
 * @property {object} addCartLocation
 * @property {object} addCartCTAType
 * @property {object} productLists
 * @property {object} cartActionCTA
 * @property {object} pesPageTypes
 * @property {object} virtualPageTypes
 * @property {object} virtualPageName
 * @property {object} pageTabs
 */

/**
 * @typedef {object} PesAnalytics
 * @property {LookupsDictionary} lookups
 */

/** @type {PesAnalytics} */
// eslint-disable-next-line prefer-destructuring
const pesAnalytics = window.pesAnalytics;

export const CONTEXT_RELATED_PRODUCTS_PARENT_ID = 'relatedProductsParentId';
export const CONTEXT_RELATED_PRODUCTS_GROUP_ID = 'relatedProductsGroupId';
export const CONTEXT_MY_PRODUCTS_PRODUCT_DATA = 'myProductsProductData';

/**
 * Save analytics temporary context value to be received later.
 *
 * @param {string} key
 * @param {*} value
 */
export function setContextValue(key, value) {
  if(!isAnalyticsEnabled()) { return; }

  if (!('context' in pesAnalytics)) {
    pesAnalytics.context = {};
  }

  pesAnalytics.context[key] = value;
}

/**
 * Get analytics temporary context value.
 *
 * @param {string} key
 * @param {object} [options]
 * @param {boolean} [options.remove] Remove context value.
 * @param {*} [options.defaultValue]
 * @returns {*}
 */
export function getContextValue(key, options = {}) {
  if (!isAnalyticsEnabled()) { return options.defaultValue || key; }

  if (!('context' in pesAnalytics)) {
    // Settings `defaultValue` means calling code expect empty values
    if (options.defaultValue !== undefined) {
      return options.defaultValue;
    }

    throw new Error('Context value must be set first');
  }

  const value = pesAnalytics.context[key];

  if (value === undefined) {
    return options.defaultValue;
  }

  if (options.remove) {
    delete pesAnalytics.context[key];
  }

  return value;
}

export * from './lookups-utils';
